"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var i18next_1 = __importDefault(require("i18next"));
var _1_png_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/1.png"));
var _2_png_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/2.png"));
var _3_png_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/3.png"));
var _4_png_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/4.png"));
var _5_png_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/5.png"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b;
    return (0, core_1.createStyles)({
        trustedByText: {
            paddingBottom: theme.spacing(4),
        },
        trustedLogosGroup: {
            justifyContent: 'center',
        },
        trustedLogoGrid: {
            display: 'flex',
            userDrag: 'none',
            alignItems: 'center',
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        trustedLogo: (_a = {
                userDrag: 'none',
                objectFit: 'contain',
                maxWidth: 'min(100%, 120px)',
                maxHeight: '70%'
            },
            _a[theme.breakpoints.up('md')] = {
                maxWidth: 'min(100%, 150px)',
            },
            _a[theme.breakpoints.up('lg')] = {
                maxWidth: 'min(100%, 180px)',
            },
            _a['@media screen\\0'] = (_b = {
                    maxWidth: '120px',
                    maxHeight: 'calc(0.7px * 120)'
                },
                _b[theme.breakpoints.up('md')] = {
                    maxWidth: '150px',
                    maxHeight: 'calc(0.7px * 150)',
                },
                _b[theme.breakpoints.up('lg')] = {
                    maxWidth: '180px',
                    maxHeight: 'calc(0.7px * 180)',
                },
                _b),
            _a),
    });
});
var TrustedBySliver = function () {
    var trustedLogos = [
        { name: i18next_1.default.t('homePage.trustedBy.1'), icon: _1_png_1.default },
        { name: i18next_1.default.t('homePage.trustedBy.2'), icon: _2_png_1.default },
        { name: i18next_1.default.t('homePage.trustedBy.3'), icon: _3_png_1.default },
        { name: i18next_1.default.t('homePage.trustedBy.4'), icon: _4_png_1.default },
        { name: i18next_1.default.t('homePage.trustedBy.5'), icon: _5_png_1.default },
    ];
    var classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, { className: classes.trustedByText, variant: "h3", color: "textPrimary", gutterBottom: true }, "Trusted by these agencies and more"),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Grid, { className: classes.trustedLogosGroup, container: true, spacing: 10 }, trustedLogos.map(function (trustedLogo) { return (react_1.default.createElement(core_1.Grid, { item: true, className: classes.trustedLogoGrid, key: trustedLogo.name, xs: 4, md: 2 },
                react_1.default.createElement("img", { className: classes.trustedLogo, src: trustedLogo.icon, alt: trustedLogo.name }))); })))));
};
exports.default = TrustedBySliver;
